import './App.css';

import { useEffect } from 'react';

import {Routes, Route, BrowserRouter as Router  } from "react-router-dom";

const Privacy = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.replace('/privacy.htm');
    }, 8);
    return () => clearTimeout(timer);
  });
  return <></>
}

function App() {
  return <Router>
    <Routes>
      <Route path={`/`} element={<></>} /> 
      <Route path={`/privacy`} element={<Privacy />}/>
    </Routes>
  </Router>
}

export default App;
